import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        style={{ margin: '2.5rem 0', textAlign: 'center', lineHeight: 1.25, maxWidth: '100%', marginLeft: 'auto', marginRight: 'auto' }}
      >
        <h1 style={{ fontSize: '3rem', fontWeight: 800, color: '#fefaf0', marginBottom: '1.25rem', overflowWrap: 'break-word', hyphens: 'auto' }}>
          {t('contact.title')}
        </h1>
        <p style={{ fontSize: '1.5rem', fontWeight: 500, color: '#fefaf0', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100%' }}>
          {t('contact.desc')}
        </p>
        <div style={{ fontSize: 22, marginTop: 40, display: 'inline-block', textAlign: 'left', background: '#dc8861', borderRadius: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.04)', padding: '2.5rem 2rem', maxWidth: '100%' }}>
          <div style={{ marginBottom: 20 }}>
            <strong>{t('footer.phone')}:</strong>{' '}
            <a href={`tel:${t('footer.phoneNumber2')}`} style={{ color: '#fefaf0', textDecoration: 'none' }}>{t('footer.phoneNumber2')}</a>
            <br />
            <a href={`tel:${t('footer.phoneNumber')}`} style={{ color: '#fefaf0', textDecoration: 'none', marginLeft: '5rem' }}>{t('footer.phoneNumber')}</a>
          </div>
          <div style={{ marginBottom: 20 }}>
            <strong>{t('footer.email')}:</strong>{' '}
            <a href={`mailto:${t('footer.emailAddress')}`} style={{ color: '#fefaf0', textDecoration: 'none', overflowWrap: 'break-word'}}>{t('footer.emailAddress')}</a>
          </div>
          <div style={{ marginBottom: 10 }}>
            <strong>{t('footer.location')}:</strong><br />
            <span>{t('footer.locationAddress')}</span><br />
            <span>{t('footer.locationAddress2')}</span>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Contact;
